import { ECivility } from "@/types/backoffice/dto/subscriber/civility-dto.ts";
import {
  ESubscriberSearchField,
  ESubscriberSearchFilterType,
} from "@/types/backoffice/dto/subscriber/subscriber-search-dto";

const subscriberLocale = {
  subscriber: {
    agreementLabel: "Accord",
    attach: "Attacher un adhérent",
    create: "Créer un adhérent",
    creation: "Création de l'adhérent",
    attachExistingSubscriber: "Attacher un adhérent existant",
    noSubscriber: {
      title: "Aucun adhérent",
      desc: "Aucun adhérent n'est relié au site",
      cta: "Attacher un adhérent",
    },
    agreement: {
      pdlMissing: "Le PDL doit être renseigné pour envoyer une lettre d'accord",
      mailMissing: "Un mail est requis pour envoyer une demande d'accord",
      sendAgreementLetter: "Envoyer une demande d'accord par mail",
    },
    transferSignature: {
      button: "Faire signer la fiche de transfert",
      openSignature: "Ouvrir la signature",
      cancelSignature: "Annuler la signature",
      loading: "Chargement des informations de l'adhérent...",
      loadError: "Impossible de charger les informations nécessaires.",
      missingDataIntro: "Informations manquantes pour la signature :",
      missingFirstName: "Prénom",
      missingLastName: "Nom",
      missingPhone: "Téléphone par défaut",
      missingEmail: "Email par défaut",
      missingPdl: "PDL",
      pendingSignature: "Signature en attente",
      modalTitle: "Faire signer la fiche de transfert",
      modalDescription: "Vérifiez les informations de l'adhérent avant de générer la signature.",
      fields: {
        name: "Nom",
        phone: "Téléphone",
        email: "Email",
        pdl: "PDL",
      },
      optionsTitle: "Consentements",
      optionUpgradeToPremium: "Voulez-vous upgrader l'adhésion en adhésion premium ?",
      optionAcceptEnergyOffers:
        "Recevoir par email et sans aucun engagement d'autres offres de service d'efficacité énergétique proposées par Voltalis",
      optionAcceptPartnerOffers: "Recevoir par email des offres commerciales de partenaires sélectionnés par Voltalis",
      confirm: "Générer et ouvrir Yousign",
      cancel: "Annuler",
    },
    myv: "Espace MyV",
    myvAccess: {
      title: "Accès à MyV",
      redirect: "Vous allez être redirigé vers l'espace personnel MyVoltalis de l'adhérent.",
      agreement: "Son accord est obligatoire pour y accéder, et cette action de votre part sera enregistrée.",
      cta: "Accéder à l'espace MyV",
      cancel: "Annuler",
      error: "Une erreur est survenue lors de la redirection",
    },
    editSubscriber: "Mettre à jour l'adhérent",
    edit: "Mise à jour de l'adhérent",
    civility: "Civilité",
    firstname: "Prénom",
    lastname: "Nom de famille",
    mailMissingPassword: "Un mail est requis pour envoyer un nouveau mot de passe",
    sendPassword: "Envoyer un nouveau mot de passe",
    mail: "Email",
    psb: "PSB",
    vip: "VIP",
    subscription: "Souscription",
    subscriptionPremium: "Service Premium",
    subscriptionPremiumPendingSignature: "Premium Service (attente signature)",
    subscriptionBasic: "Service Basic ",
    myvBasic: "MyVoltalis Basic",
    subscriberOfferModal: {
      title: "Vous confirmez que votre interlocuteur renonce au service premium comprenant:",
      features: {
        base: "Les {boldText} (suivi des consommations, programmations, détection d'absence)",
        boldText: "fonctionnalités de thermostat avancées",
      },
      support: {
        base: "Le {boldText} (ligne téléphonique dédiée ou email)",
        boldText: "support 7j/7",
      },
      warranty: {
        base: "La {boldText}",
        boldText: "garantie illimitée",
      },
      expert: {
        base: "Les échanges avec des experts pour {boldText}",
        boldText: "optimiser vos économies d'énergie",
      },
      buttons: {
        premiumService: "Conserver le service premium",
      },
    },
    unsetPrivileged: "Retirer Tag PSB",
    setPrivileged: "Ajouter Tag PSB",
    unsetVIP: "Retirer Tag VIP",
    setVIP: "Ajouter Tag VIP",
    additionalMail: "Emails supplémentaires",
    phone: "Téléphone",
    additionalPhone: "Téléphones supplémentaires",
    civilities: {
      [ECivility.MALE]: "Monsieur",
      [ECivility.FEMALE]: "Madame",
      [ECivility.MISS]: "Mademoiselle",
      [ECivility.UNKNOWN]: "Inconnu",
    },
    filterTypes: {
      [ESubscriberSearchFilterType.EQUALS]: "Est...",
      [ESubscriberSearchFilterType.CONTAINS]: "Contient...",
      [ESubscriberSearchFilterType.STARTS_BY]: "Démarre par...",
      [ESubscriberSearchFilterType.ENDS_BY]: "Fini par...",
    },
    fields: {
      [ESubscriberSearchField.ID]: "ID Adhérent",
      [ESubscriberSearchField.LASTNAME]: "Nom",
      [ESubscriberSearchField.FIRSTNAME]: "Prénom",
      [ESubscriberSearchField.EMAIL]: "Email",
      [ESubscriberSearchField.PHONE]: "Numéro de téléphone",
    },
  },
};

export type SubscriberLocale = typeof subscriberLocale;
export default subscriberLocale;
